<div class="dialog">
  <div class="header">
    <div>
      <h2>Product Approval Status</h2>
      <p>{{ data.companyName }}</p>
    </div>
    <button mat-icon-button type="button" aria-label="Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (isLoading) {
    <div class="loading">
      <mat-spinner [diameter]="28"></mat-spinner>
      <span>Loading product approval status...</span>
    </div>
  }

  @if (!isLoading) {
    @if (!rows.length) {
      <div class="empty">
        No approval-required payroll products were found for this company.
      </div>
    }
    @if (rows.length) {
      <div class="table-wrap">
        <table class="status-table">
          <thead>
            <tr>
              <th>Provider</th>
              <th>Plan</th>
              <th>Status</th>
              <th>Requested By</th>
              <th>Requested At</th>
              <th>Ready At</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row) {
              <tr>
                <td>{{ row.providerName || '--' }}</td>
                <td>{{ row.planName || '--' }}</td>
                <td>
                  <span class="status-pill" [class.ready]="row.status === 'ready'" [class.pending]="row.status === 'pending'">
                    {{ getStatusLabel(row) }}
                  </span>
                </td>
                <td>{{ row.requestedBy.name || '--' }}</td>
                <td>{{ row.requestedAt ? (row.requestedAt | date:'short') : '--' }}</td>
                <td>{{ row.readyAt ? (row.readyAt | date:'short') : '--' }}</td>
                <td class="actions-col">
                  @if (canMarkReady(row)) {
                    <button
                      mat-stroked-button
                      type="button"
                      [disabled]="isUpdating(row)"
                      (click)="markReady(row)"
                      >
                      Mark Ready
                    </button>
                  }
                  @if (canDelete(row)) {
                    <button
                      mat-button
                      color="warn"
                      type="button"
                      [disabled]="isUpdating(row)"
                      (click)="deleteRequest(row)"
                      >
                      Delete
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    <div class="footer">
      <button mat-stroked-button type="button" (click)="close()">Close</button>
    </div>
  }
</div>
